module.exports = __webpack_public_path__ + "static/media/bp-right.b7eeac06.webp";